import axios from 'axios';
import config from '../Config'; // Path to your config file
import authHeader from './auth-header'; // Path to your auth header


const API_URL = config.API_URL; // Base API URL
const API_VERSION = config.API_VERSION; // API version
const addVehicle = (formData) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/vehiclemaster/`,
    formData, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const getVehicleList = (page, pagesize, search, ordering,signal) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/vehiclemaster/`, {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    },
    signal, 
  });
};

const getVehicleDropdown = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/vehiclemaster/`, {
    headers: authHeader(),
    params: {
      fields: 'id, name, deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getVehicleArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/vehiclemaster-archive', {
    headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    }
  });
};
const updateVehicle = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/vehiclemaster/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};

const deleteVehicle = (id) => {
   
  return axios.delete(
      `${API_URL}/api/${API_VERSION}/vehiclemaster/${id}/`,
      { headers: authHeader() }, // Authentication header
    );
};
const unArchiveVehicle = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/vehiclemaster/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};
const vehicleService = {
  addVehicle,
  getVehicleList,
  getVehicleArchiveList,
  updateVehicle,
  deleteVehicle,
  unArchiveVehicle,
  getVehicleDropdown
};

export default vehicleService;
